import { useDispatch, useSelector } from 'react-redux';
import AsyncSelect from 'react-select/async';
import { SingleValue } from 'react-select';
import { gql } from '@apollo/client';
import graphQlClient from 'api/graphQlClient';
import { changeDefaultCargo } from 'store/feature/userSlice';
import Tooltip from 'rc-tooltip';
import { RootState } from 'store';

type CargoOption = { value: string | null; label: string };

const panelContainerStyle: React.CSSProperties = {
    textAlign: 'left',
    display: 'inline-grid',
    lineHeight: '1.5',
    marginTop: '5px',
    marginLeft: '50px',
    width: '150px',
    maxWidth: '150px',
};

const NONE_OPTION: CargoOption = { value: null, label: 'None' };

const SEARCH_CARGOES = gql`
    query DefaultCargoSearch($search: String!, $groupId: ID!) {
        cargoes(searchTerm: $search, groupId: $groupId) {
            id
            fullName
        }
    }
`;

const DefaultCargoPanelItems = () => {
    const dispatch = useDispatch();

    const groupId = useSelector(
        (state: RootState) => state.user.group?.id ?? null
    );
    const defaultCargo = useSelector(
        (state: RootState) => state.user.uiSettings?.defaultCargo ?? null
    );

    const currentValue: CargoOption = defaultCargo
        ? { value: defaultCargo.id, label: defaultCargo.fullName }
        : NONE_OPTION;

    const loadOptions = async (inputValue: string): Promise<CargoOption[]> => {
        if (!inputValue || !groupId) return [];
        try {
            const result = await graphQlClient().query<{
                cargoes: {
                    id: string;
                    fullName: string;
                }[];
            }>({
                query: SEARCH_CARGOES,
                fetchPolicy: 'no-cache',
                variables: { search: inputValue, groupId },
            });
            return result.data.cargoes.map((c) => ({
                value: c.id,
                label: c.fullName,
            }));
        } catch (err) {
            console.error('Failed to search cargoes', err);
            return [];
        }
    };

    const handleChange = async (option: SingleValue<CargoOption>) => {
        try {
            await dispatch(changeDefaultCargo(option?.value ?? null));
        } catch (err) {
            console.error('Failed to change default cargo', err);
        }
    };

    return (
        <div style={panelContainerStyle}>
            <Tooltip
                placement="left"
                overlay={defaultCargo?.fullName ?? ''}
                trigger={defaultCargo ? ['hover'] : []}
                {...(!defaultCargo && { visible: false })}
            >
                <div>
                    <AsyncSelect
                        className="basic-single"
                        classNamePrefix="list"
                        isClearable={!!defaultCargo}
                        loadOptions={loadOptions}
                        value={currentValue}
                        onChange={handleChange}
                        menuPlacement="auto"
                        placeholder="Search cargo..."
                        noOptionsMessage={({ inputValue }) =>
                            inputValue
                                ? 'No matching cargoes'
                                : 'Type to search cargoes'
                        }
                        defaultOptions={false}
                    />
                </div>
            </Tooltip>
        </div>
    );
};

export default DefaultCargoPanelItems;
